import React, { useState, useEffect } from "react";
import { clearSession } from "../shared/_helpers/session";
import { checkBlockedStatus, getAllUserList, getUsersListByAdvisorId,blockUnblockUser } from "../shared/_services/common.services";
import TableComponent from "./TableComponent";
import { useSnackbar } from "notistack";
import Loader from "./Loader";
import { useNavigate } from "react-router-dom";
import Pagination from "./Pagination";

import StarsIcon from "../styles/StarsIcon";
import { Button, Dialog, DialogContent, DialogTitle, Page, PageHead } from "./ui";

const UserList = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [userData, setUserData] = useState([]);
  const role = JSON.parse(localStorage.getItem("currentUser"))?.user?.userType;
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(10);

  const [confirmBlockPopupShow, setConfirmBlockPopupShow] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [blockAction, setBlockAction] = useState('');


  const headers = {
    "advisor": ["Name", "Subscription Type", "E-mail", "Member Since"],
    "super-admin": ["Name", "Financial Advisor", "Subscription Type", "E-mail","Block","Member Since"],
    "admin": ["Name", "Financial Advisor", "Subscription Type", "E-mail", "Block", "Member Since"]
  };


  const getUsersData = async () => {
    setShowLoader(true);

    let response;
    if (role === "advisor") {
      response = await getUsersListByAdvisorId(JSON.parse(localStorage.getItem("currentUser"))?.user?._id);
    } else {
      response = await getAllUserList("client");
    }

    if (response.status === 200) {
      setUserData(response.data);
    } else {
      if (response?.response?.status === 401) {
        clearSession();
        enqueueSnackbar("Your session has been expired!", {
          variant: "error",
          anchorOrigin: { horizontal: "right", vertical: "top" },
        });
        navigate("/login");
      }
    }

    setShowLoader(false);
  };

  const checkBlocked = async () => {
    const userId = JSON.parse(localStorage.getItem('currentUser')).user?._id;
    try {
      // Call the API to check the user's blocked status
      const response = await checkBlockedStatus(userId);
      
      if (response.data ? response.status == 401 : response.response.status == 401) {
        clearSession();
        navigate("/login");
      }
      else {
        const { isBlocked, isDeleted } = response.data;

        if (isBlocked || isDeleted) {
          // Clear the currentUser from localStorage
          clearSession();

          // Navigate to the login page
          navigate("/login");
        }
      }
    } catch (error) {
      console.error("Error checking blocked status:", error);
      // Optionally handle errors, e.g., show an error message
    }
  }

  const confirmBlockPopupClose = () => setConfirmBlockPopupShow(false);

  const openConfirmBlockPopup = (user) => {
    setSelectedUser(user);
    setBlockAction(user.status ? 'block' : 'unblock'); // assuming status = true means active
    setConfirmBlockPopupShow(true);
  };

  const handleBlock = async () => {
  setConfirmBlockPopupShow(false);
  setShowLoader(true);
  const userId = selectedUser._id;
  const newStatus = !selectedUser.status; // toggles

  try {
    await blockUnblockUser({ userId, status: newStatus });
    getUsersData();
    const action = newStatus ? "unblocked" : "blocked";
    enqueueSnackbar(`Client ${action} successfully`, { variant: "success" });
  } catch (error) {
    const action = newStatus ? "unblock" : "block";
    enqueueSnackbar(`Failed to ${action} client`, { variant: "error" });
  } finally {
    setShowLoader(false);
  }
};



  useEffect(() => {
    checkBlocked();
    getUsersData();
  }, []);

  //pagination code
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = userData.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(userData.length / recordsPerPage)

  return (
    <Page>
      <PageHead title="Clients" />
      {showLoader ? <Loader /> :
        <>
          <TableComponent headers={headers[role]} data={currentRecords} test={"temp"} onBlockUserClick={openConfirmBlockPopup}/>
          <Pagination
            nPages={nPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </>}

      <Dialog
        open={confirmBlockPopupShow}
        onOpenChange={(open) => { if (!open) confirmBlockPopupClose(); }}
      >
        <DialogContent
          onInteractOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}
          className="tw-text-center"
        >
          <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
            <span />
            <Button
              variant="icon"
              size="sm"
              iconOnly
              aria-label="Close"
              className="tw-border-solid tw-shrink-0"
              onClick={confirmBlockPopupClose}
            >
              <StarsIcon name="x" className="tw-h-4 tw-w-4 tw-shrink-0" />
            </Button>
          </div>
          <DialogTitle>
            {`You are attempting to ${blockAction === 'block' ? 'block' : 'unblock'} ${selectedUser ? selectedUser.firstName : ''
              }.`}
          </DialogTitle>
          <p className="tw-m-0 tw-text-md tw-font-bold tw-text-text">Are you sure?</p>
          <div className="tw-mt-6 tw-flex tw-justify-center">
            <Button onClick={handleBlock}>
              {blockAction === 'block' ? 'Block' : 'Unblock'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </Page>
  );
};

export default UserList;
